module.exports = __webpack_public_path__ + "img/09.42061d53.gif";